import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userPaymentList: null,               
    userPaymentPath: '/userPayment', 
    userPaymentDetails:null, 
    selectedPayment:null
};


const userPaymentSlice = createSlice({
    name: 'userPayment',
    initialState,
    reducers: {
        setUserPaymentList: (state, action) => {
            state.userPaymentList = action.payload;
        },

     
        setUserPaymentPath: (state, action) => {
            state.userPaymentPath = action.payload;
        },
        setUserPaymentDetails:(state, action)=>{
            state.userPaymentDetails=action.payload;
        },
        setSelectedPayment :(state, action)=>{
            state.selectedPayment=action.payload;
        }
    },


    extraReducers: (builder) => {
        builder.addCase('RESET_STATE', () => initialState);
    }
});

export const { setUserPaymentDetails, setUserPaymentList, setUserPaymentPath, setSelectedPayment } = userPaymentSlice.actions;

export default userPaymentSlice.reducer;
